// true  -> tags are rendered as a foldable group at the end of the tree (tags/tags-group.tsx)
// false -> tags are rendered as a separate menu section below the tree (tags/tags.tsx)
export const TAGS_AS_TREE_GROUP = true
